import {
  GetV1CompaniesCompanyIdPayCommissionDefaultsData,
  PayCommissionDefault_Create,
  PayCommissionDefault_Read,
  PayCommissionDefault_Update,
} from '@treadinc/horizon-api-spec';
import dayjs, { Dayjs } from 'dayjs';

import { CommissionDefaultFormData } from '~pages/Settings/RatesManagement/CommissionDefaults/commissionDefaultSchema';

export type CommissionPayeeType = NonNullable<
  NonNullable<GetV1CompaniesCompanyIdPayCommissionDefaultsData['query']>['payee_type']
>;

export class PayCommissionDefault {
  constructor(
    private _id: PayCommissionDefault_Read['id'],
    private _company_id: PayCommissionDefault_Read['company_id'],
    private _driver_id: PayCommissionDefault_Read['driver_id'],
    private _vendor_account_id: PayCommissionDefault_Read['vendor_account_id'],
    private _payee_name: PayCommissionDefault_Read['payee_name'],
    private _rate_type: PayCommissionDefault_Read['rate_type'],
    private _percentage: PayCommissionDefault_Read['percentage'],
    private _created_at: Dayjs,
    private _updated_at: Dayjs,
  ) {}

  public static parse(proto: PayCommissionDefault_Read) {
    return new PayCommissionDefault(
      proto.id,
      proto.company_id,
      proto.driver_id ?? null,
      proto.vendor_account_id ?? null,
      proto.payee_name,
      proto.rate_type,
      proto.percentage,
      dayjs(proto.created_at),
      dayjs(proto.updated_at),
    );
  }

  public static deparseCreate(
    formData: CommissionDefaultFormData,
    isDriver: boolean,
  ): PayCommissionDefault_Create {
    return {
      driver_id: isDriver ? formData.payee.value : null,
      vendor_account_id: isDriver ? null : formData.payee.value,
      rate_type: formData.rateType.value,
      percentage: formData.percentage,
    };
  }

  public static deparseUpdate(
    formData: CommissionDefaultFormData,
  ): PayCommissionDefault_Update {
    return { percentage: formData.percentage };
  }

  public get id() {
    return this._id;
  }
  public get companyId() {
    return this._company_id;
  }
  public get driverId() {
    return this._driver_id;
  }
  public get vendorAccountId() {
    return this._vendor_account_id;
  }
  public get payeeName() {
    return this._payee_name;
  }
  public get rateType() {
    return this._rate_type;
  }
  public get percentage() {
    return this._percentage;
  }
  public get createdAt() {
    return this._created_at;
  }
  public get updatedAt() {
    return this._updated_at;
  }
}
